import { render, staticRenderFns } from "./Variant.vue?vue&type=template&id=2d289fc2"
import script from "./Variant.vue?vue&type=script&lang=js"
export * from "./Variant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports